import type { Ref } from "vue";
import {
  PATH_PERMISSIONS_ADMINISTRATION,
  PATH_PERMISSIONS_OPERATOR,
} from "~/core/constants/paths";
import { OrganizationType } from "~/modules/organization/models/OrganizationType.enum";
import type { OrganizationTypeOption } from "~/modules/organization/models/OrganizationTypeOption.interface";

export const PATH_ORGANIZATIONS = "/organizations";
export const PATH_ORGANIZATIONS_ID = `${PATH_ORGANIZATIONS}/:id`;
export const PATH_ORGANIZATIONS_ID_SETTINGS = `${PATH_ORGANIZATIONS_ID}/settings`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_CERTIFICATE = `${PATH_ORGANIZATIONS_ID_SETTINGS}/certificate`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_CERTIFICATE_TRUSTSTORE = `${PATH_ORGANIZATIONS_ID_SETTINGS_CERTIFICATE}/truststore`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_CERTIFICATE_TRUSTSTORE_ALIAS = `${PATH_ORGANIZATIONS_ID_SETTINGS_CERTIFICATE_TRUSTSTORE}/:alias`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_INFORMATION = `${PATH_ORGANIZATIONS_ID_SETTINGS}/information`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_LOGS = `${PATH_ORGANIZATIONS_ID_SETTINGS}/logs`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_LICENSE = `${PATH_ORGANIZATIONS_ID_SETTINGS}/license`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT = `${PATH_ORGANIZATIONS_ID_SETTINGS}/user-management`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT}/profiles`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES_ID = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES}/:profileId`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES_ID_PERMISSIONS_ADMINISTRATION = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES_ID}${PATH_PERMISSIONS_ADMINISTRATION}`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES_ID_PERMISSIONS_OPERATOR = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_PROFILES_ID}${PATH_PERMISSIONS_OPERATOR}`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT}/users`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS_LOGIN = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS}/:userLogin`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS_LOGIN_INFORMATION = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS_LOGIN}/information`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS_LOGIN_DELEGATION = `${PATH_ORGANIZATIONS_ID_SETTINGS_USER_MANAGEMENT_USERS_LOGIN}/delegation`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS = `${PATH_ORGANIZATIONS_ID_SETTINGS}/relations`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_AFFILIATIONS = `${PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS}/affiliations`;
export const PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS_DELEGATIONS = `${PATH_ORGANIZATIONS_ID_SETTINGS_RELATIONS}/delegations`;

export const typeOptions: Ref<OrganizationTypeOption[]> = ref([
  {
    key: OrganizationType.ADMINISTRATION,
    labelKey: "administration.organization.type.administration",
  },
  {
    key: OrganizationType.OPERATOR,
    labelKey: "administration.organization.type.operator",
  },
]);
